import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";
import InitialsAvatar from "./InitialsAvatar";

// Admin · Page Head (047 kit; user 10704:8840, child 10763:81301): the XL square avatar,
// the name and its soft chips, lines of info under the name, the actions on the right.
export const PageHead = ({ name, colorKey, src, chips = [], lines, meta, actions, align = "flex-start", actionsGap = "8px" }) => (
  <Box sx={{ display: "flex", alignItems: align, gap: "16px", flexWrap: "wrap" }}>
    <InitialsAvatar name={name} colorKey={colorKey} src={src} size={72} square />
    <Box sx={{ flex: { xs: "1 1 0%", md: "1 1 320px" }, minWidth: 0, display: "flex", flexDirection: "column", gap: "6px" }}>
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
        <Typography variant="titleMedium" sx={{ color: tokens.text.primary, overflowWrap: "anywhere" }}>
          {name}
        </Typography>
        {chips.map((c) => (
          <Chip key={c.label} label={c.label} color={c.color} />
        ))}
      </Box>
      {lines}
      {meta && (
        <Typography variant="labelMedium" component="div" sx={{ color: tokens.text.tertiary }}>
          {meta}
        </Typography>
      )}
    </Box>
    {actions && (
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: actionsGap, flexShrink: 0, maxWidth: "100%" }}>{actions}</Box>
    )}
  </Box>
);

// The head's info line: items 18 px apart, wrapping.
export const InfoRow = ({ children, rowGap = "6px" }) => (
  <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", rowGap, columnGap: "18px" }}>{children}</Box>
);

// One item of the info line: a 16 px icon and its text.
export const InfoItem = ({ Icon, children, color = tokens.text.secondary }) => (
  <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: "6px", minWidth: 0, color, typography: "bodySmall", overflowWrap: "anywhere" }}>
    {Icon && <Icon size={16} />}
    {children}
  </Box>
);

// A list page's head (Page head 10620:2413): the menu group as a caption, the page's name,
// and a line under it. The line keeps its height while it is empty, so the page does not
// move when a count lands.
export const ListHead = ({ caption, title, subtitle }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
    <Typography variant="labelCaption" sx={{ color: tokens.text.tertiary }}>
      {caption}
    </Typography>
    <Typography variant="titleMedium" sx={{ color: tokens.text.primary }}>
      {title}
    </Typography>
    <Typography variant="bodySmall" sx={{ color: tokens.text.tertiary, minHeight: 22 }}>
      {subtitle}
    </Typography>
  </Box>
);
